import Vue from "vue";
import store from "./store";
import App from "./App";
import router from "./router";
import "@/icons";
import _ from "lodash";
import "@/styles/index.scss"; // global css
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
Vue.use(ElementUI);
import { MessageBox } from "element-ui";
Vue.prototype.$comfirm = MessageBox.confirm;
Vue.component("icon", Icon);
// 导入字体
import "./assets/font/iconfont.css";
import CustomIcon from "@/components/CustomIcon/index.vue";
Vue.component("custom-icon", CustomIcon);

// 弹窗样式
import "@/assets/styles/dialog.less";
// 前置守卫
import "@/permission";

// svgIcon
import Icon from "vue2-svg-icon/Icon";

// 轮播图
import VueAwesomeSwiper from "vue-awesome-swiper";
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

// 视频播放器
import VueCoreVideoPlayer from "vue-core-video-player";
Vue.use(VueCoreVideoPlayer, {
  lang: "zh-CN"
});
import VideoPlayer from "vue-video-player";
window.videojs = VideoPlayer.videojs;

require("vue-video-player/src/custom-theme.css");
require("video.js/dist/video-js.min.css");
require("video.js/dist/lang/zh-CN.js");
Vue.use(VideoPlayer);

//自定义loading
import DirectiveLoading from "./directiveLoading";
Vue.use(DirectiveLoading);

import VuePullInfiniteScroller from "vue-pull-infinite-scroller";
Vue.use(VuePullInfiniteScroller);
// 引入useComponent文件，进行注册插件，可以一次注册多个
import useComponent from "./utils/useComponent";
Vue.use(useComponent);

Vue.config.productionTip = false;

// 引入公共方法
import { timeFormatSeconds } from "@/utils/setTimer.js";
import { utf16ToEntities, entitiesToUtf16, haveEmoji } from "@/utils/utils.js";
// 全局引入global 公共变量
import global from "@/global/global.js";
Vue.prototype.global = global;
// 挂在到Vue实例上
Vue.prototype.$timeFormatSeconds = timeFormatSeconds;
Vue.prototype.$utf16ToEntities = utf16ToEntities;
Vue.prototype.$entitiesToUtf16 = entitiesToUtf16; //表情解码
Vue.prototype.$haveEmoji = haveEmoji; //表情解码

// 跳转回到顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = scrollTo(0, 880);
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});

// 渐进式图片加载
import progressive from "progressive-image/dist/vue"; // 渐进式
Vue.use(progressive, {
  removePreview: true,
  scale: true
});

import Api from "../public/api.js";

// 将Api对象绑定在vue实例的原型上
Vue.prototype.$Api = Api;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js